module.exports = "<tb-order-overview-react></tb-order-overview-react>\n";